import "homeland/index";
import "vendor/bootstrap";
import "front/index";

const images = require.context('./images', true)
